import * as z from 'zod';

import { companyQuerySchema } from '@/_pages/companies/shared/schemas';
import { systemUserQueryLinkerSchema } from '@/_pages/system-users/shared/schemas';
import { teamMemberQueryLinkerSchema } from '@/_schemas/team-members/team-members-query-linker-schema';

export const pickerSchema = z.union([systemUserQueryLinkerSchema, teamMemberQueryLinkerSchema]);
export const pickerTypeSchema = z.union([z.literal('user'), z.literal('team-member')]);
export type PickerTypeSchema = z.infer<typeof pickerTypeSchema>;

export const companyFilteredSchema = companyQuerySchema.pick({
  id: true,
  name: true,
  logo: true,
  account_number: true,
  contacts: true,
});

export type CompanyFilteredSchema = z.infer<typeof companyFilteredSchema>;
